import { CustomOrderType } from '../../carts/CustomOrderType';
import { RemoveAllDiscountCodesFromCartResult } from '../../../graphql/cart/removeAllDiscountCodesFromCarts';
import { createAction } from '@reduxjs/toolkit';

export interface ApiRemoveAllDiscountCodesFromCartsRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly parentActionId: number;
}

export const apiRemoveAllDiscountCodesFromCartsRequestedType =
  'api/cart/removeAllDiscountCodesFromCarts--requested';
export const apiRemoveAllDiscountCodesFromCartsRequested =
  createAction<ApiRemoveAllDiscountCodesFromCartsRequestedPayload>(
    apiRemoveAllDiscountCodesFromCartsRequestedType
  );
export type ApiRemoveAllDiscountCodesFromCartsRequestedAction = ReturnType<
  typeof apiRemoveAllDiscountCodesFromCartsRequested
>;

export interface ApiRemoveAllDiscountCodesFromCartsSucceededPayload {
  readonly cartId: string;
  readonly result: RemoveAllDiscountCodesFromCartResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiRemoveAllDiscountCodesFromCartsSucceededType =
  'api/cart/removeAllDiscountCodesFromCarts--succeeded';
export const apiRemoveAllDiscountCodesFromCartsSucceeded =
  createAction<ApiRemoveAllDiscountCodesFromCartsSucceededPayload>(
    apiRemoveAllDiscountCodesFromCartsSucceededType
  );
export type ApiRemoveAllDiscountCodesFromCartsSucceededAction = ReturnType<
  typeof apiRemoveAllDiscountCodesFromCartsSucceeded
>;

export interface ApiRemoveAllDiscountCodesFromCartsFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiRemoveAllDiscountCodesFromCartsFailedType =
  'api/cart/removeAllDiscountCodesFromCarts--failed';
export const apiRemoveAllDiscountCodesFromCartsFailed =
  createAction<ApiRemoveAllDiscountCodesFromCartsFailedPayload>(
    apiRemoveAllDiscountCodesFromCartsFailedType
  );
export type ApiRemoveAllDiscountCodesFromCartsFailedAction = ReturnType<
  typeof apiRemoveAllDiscountCodesFromCartsFailed
>;
